import React from 'react';
import { Link } from 'react-router-dom';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Footer from '../Footer/Footer';
import { formatDate } from 'utils/date';

import useComicPosts from 'hooks/useComicPosts';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

export default function Comic() {
  const { isLoading, comicPosts } = useComicPosts();

  if (isLoading) {
    return null;
  }

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="news"
    >
      <Helmet>
        <title>Webcomic - DuskBreakers</title>
        <meta
          name="description"
          content="Explore the DuskBreakers universe through our exciting webcomic."
        />
      </Helmet>

      <section>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="mb-5">Webcomic</h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            {comicPosts.map(({ id, slug, thumbnailUrl, title, publishDate }) => {
              return (
                <div key={id} className="col-12">
                  <div className="card mb-3">
                    <div className="card-body">
                      <Link
                        className="posts__post noline stretched-link"
                        to={`/comic/${id}/${slug}`}
                      >
                        <div className="row gx-4">
                          <div className="col-3 col-md-2">
                            <LazyLoadImage
                              className="img-fluid w-100"
                              alt={title}
                              src={thumbnailUrl}
                              effect="opacity"
                            />
                          </div>
                          <div className="col-9 col-md-10 d-flex flex-direction-row justify-content-between align-items-center">
                            {title}
                            <div className="text-muted">
                              <span>{formatDate(publishDate)}</span>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <Footer />
    </m.main>
  );
}
